import dayjs from 'dayjs';
import { View, Views } from 'react-big-calendar';

type IVisibleRangeReturn = { start: Date; end: Date };

export function getVisibleRange(currentView: View, currentDate: Date): IVisibleRangeReturn {
  const date = dayjs(currentDate);
  const weekStart = date.startOf('week');
  const weekEnd = date.endOf('week');

  switch (currentView) {
    case Views.DAY:
      return { start: date.startOf('day').toDate(), end: date.endOf('day').toDate() };

    case Views.WEEK:
      return { start: weekStart.startOf('day').toDate(), end: weekEnd.endOf('day').toDate() };

    case Views.MONTH: {
      const first = date.startOf('month').startOf('week');
      const last = date.endOf('month').endOf('week');

      return { start: first.startOf('day').toDate(), end: last.endOf('day').toDate() };
    }
  }

  return { start: weekStart.startOf('day').toDate(), end: weekEnd.endOf('day').toDate() };
}
